package com.anjuros.website.templates.template9.modules

import com.anjuros.website.templates.template9.util.ResKey

enum class Template9Section(
    val id: String,
    val title: ResKey,
    val path: String
) {
    Home(
        id = "home",
        title = ResKey.TEMPLATE9_SECTION1,
        path = "#home"
    ),
    Services(
        id = "services",
        title = ResKey.TEMPLATE9_SECTION2,
        path = "#services"
    ),
    AboutMe(
        id = "aboutme",
        title = ResKey.TEMPLATE9_SECTION3,
        path = "#aboutme"
    ),
    FAQ(
        id = "faq",
        title = ResKey.TEMPLATE9_SECTION4,
        path = "#faq"
    ),
    Contact(
        id = "contact",
        title = ResKey.TEMPLATE9_SECTION5,
        path = "#contact"
    )
}
